/* "Complete the set" (snippets/cs-set.liquid): live total + add the ticked items.
   Adds go through /cart/add.js in one request, then the response is handed to the
   cart drawer exactly as the product cards do (assets/cs-pcard.js), so the shopper
   lands in the same drawer with the same upsells. */
(function () {
  if (window.__csSet) return;
  window.__csSet = true;

  var inr = function (paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); };

  function festOn(root) {
    if (root.getAttribute('data-fest') !== '1') return false;
    var now = Date.now(), s = Date.parse(root.getAttribute('data-start')), e = Date.parse(root.getAttribute('data-end'));
    return !(now < s) && !(now > e);
  }

  // Is the add-on going to be the theme's free gift? Only while the festival runs, only if
  // the add-on IS the gift variant, and only when the OTHER ticked items reach the gift
  // threshold below the 15% tier (cs-fest.liquid adds the gift under the same rule).
  function giftFree(root) {
    var addon = root.querySelector('.cs-set__tick[data-addon]');
    if (!addon || !addon.checked || !festOn(root)) return false;
    if (addon.getAttribute('data-vid') !== root.getAttribute('data-gift-vid')) return false;
    var others = [].slice.call(root.querySelectorAll('.cs-set__tick')).filter(function (t) { return t !== addon && t.checked; });
    var sum = others.reduce(function (a, t) { return a + +t.getAttribute('data-price'); }, 0);
    return others.length < 3 && sum >= +root.getAttribute('data-gift-min');
  }

  function update(root) {
    var ticks = [].slice.call(root.querySelectorAll('.cs-set__tick')).filter(function (t) { return t.checked; });
    var n = ticks.length, price = 0, compare = 0;
    ticks.forEach(function (t) { price += +t.getAttribute('data-price'); compare += +t.getAttribute('data-compare'); });
    var on = festOn(root), pct = +root.getAttribute('data-pct');
    var addon = root.querySelector('.cs-set__tick[data-addon]');
    var gift = giftFree(root), total;
    if (gift) {
      // Cart = the others + the free gift. Shopify applies the bigger of the two (no stacking).
      var addonPrice = +addon.getAttribute('data-price');
      var others = price - addonPrice;
      total = Math.min(others, price * (100 - pct) / 100);
    } else {
      total = price * (100 - (on && n >= 2 ? pct : 0)) / 100;
    }
    if (addon) {
      var pe = addon.closest('.cs-set__row').querySelector('[data-cs-set-price]');
      if (!pe.hasAttribute('data-orig')) pe.setAttribute('data-orig', pe.innerHTML);
      pe.innerHTML = gift ? '<span class="cs-set__free">FREE gift</span> <s>' + inr(+addon.getAttribute('data-price')) + '</s>' : pe.getAttribute('data-orig');
    }
    var title = root.querySelector('[data-cs-set-title]');
    if (title) title.textContent = on ? title.getAttribute('data-on') : title.getAttribute('data-off');
    var deal = root.querySelector('[data-cs-set-deal]'); if (deal) deal.hidden = !on;
    root.querySelector('[data-cs-set-count]').textContent = n > 1 ? 'Total for ' + n + ':' : 'Total:';
    root.querySelector('[data-cs-set-now]').textContent = inr(total);
    var was = root.querySelector('[data-cs-set-was]');
    was.textContent = compare > total + 50 ? inr(compare) : '';
    var save = root.querySelector('[data-cs-set-save]');
    save.hidden = !(compare > total + 50);
    save.textContent = 'Save ' + inr(compare - total);
    root.querySelector('[data-cs-set-add]').textContent = n > 1 ? 'Add all ' + n + ' to cart' : 'Add to cart';
  }

  function cartTarget() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function') return d;
    var n = document.querySelector('cart-notification');
    if (n && typeof n.renderContents === 'function') return n;
    return null;
  }

  function add(root, btn) {
    var gift = giftFree(root);
    var items = [].slice.call(root.querySelectorAll('.cs-set__tick')).filter(function (t) { return t.checked && !(gift && t.hasAttribute('data-addon')); })
      .map(function (t) { return { id: +t.getAttribute('data-vid'), quantity: 1 }; });
    var msg = root.querySelector('[data-cs-set-msg]');
    var target = cartTarget();
    var body = { items: items };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.setAttribute('aria-busy', 'true'); msg.hidden = true;
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { msg.textContent = data.description || data.message || 'Could not add these items.'; msg.hidden = false; return; }
        if (!target) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
        // Same as cs-pcard.js: the element-level is-empty class would hide the drawer header.
        if (target.classList.contains('is-empty')) target.classList.remove('is-empty');
        target.renderContents(data);
        // The theme adds the free gift on cart changes (cs-fest.liquid listens for these).
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cs-set' });
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () { msg.textContent = 'Network problem. Please try again.'; msg.hidden = false; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cs-set]').forEach(function (root) {
      if (root.__csSetBound) return; root.__csSetBound = true;
      root.addEventListener('change', function (e) { if (e.target.classList.contains('cs-set__tick')) update(root); });
      root.querySelector('[data-cs-set-add]').addEventListener('click', function (e) {
        if (e.currentTarget.getAttribute('aria-busy') === 'true') return;
        add(root, e.currentTarget);
      });
      update(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
